import { render } from "./ModalUploadFile.vue?vue&type=template&id=903a0cbe&bindings={}"
import script from "./ModalUploadFile.vue?vue&type=script&lang=ts"
export * from "./ModalUploadFile.vue?vue&type=script&lang=ts"

import "./ModalUploadFile.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script